export const ROUTE_PATH = '/reconciliation-refunds/store[eq]=:store_id';

export const ARCHIVE_ROUTE_PATH =
  '/reconciliation-refunds/reconciliation_id[eq]=:reconciliation_id&store_id[eq]=:store_id';

export const FEATURE_NAME = 'reconciliationRefundsPage';
